module.exports = __webpack_public_path__ + "img/logo-extended.238757b0.png";